<template>
    <div class="container col-md-12" id="Comissoes">

        <vuestic-widget id="" headerText="Relatório Comissão - Consultor">
            
            <div class="col-sm-12">

                <div id="formulario_consulta_comissao" class="row py-3">

                    <fieldset class="col-sm-4 mb-3">
                        <legend for="cfc" class="form-label d-flex">{{ form.consultor.title }}</legend>
                        <select v-model="selectedConsultor" id="cfc" class="custom-select border">
                            <option v-for="(consultor, index) in selectConsultor" :value="consultor.value" :key="index">
                                {{ consultor.text }}
                            </option>
                        </select>
                    </fieldset>

                    <fieldset class="col-sm-4 mb-3">
                        <legend for="cfc" class="form-label d-flex">{{ form.periodo.title }}</legend>
                        <input v-model="form.periodo.value" class="form-control border w-100" type="month" id="month">
                    </fieldset>

                    <div class="col-sm-4 text-right">
                        <legend class="espacamento-oculto">.</legend>
                        <button @click="gerarPDF()" class="btn btn-success col-12 btn-micro" :disabled="form.button.disabled">
                            <div v-if="loadConsulta" class="spinner-grow text-secondary mr-3" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <i v-else class="fa fa-file mr-3" aria-hidden="true"></i>
                            <span class="font-button-modified">{{ form.button.title }}</span>
                        </button>
                    </div>

                </div>

            </div>

            <a href="#" hidden id="aulasPDF"></a>

        </vuestic-widget>

    </div>
</template>

<script>

import urlApi from "@/router/urlApi";
import urlApiV2 from '@/router/urlApiV2'
import * as spinners from "epic-spinners";

export default {

    name: "Comissoes",
    components: {
        urlApi,
        ...spinners,
    },

    data () {
        return {
            selectedConsultor: '',
            selectConsultor: [
                { value: '', text: 'Selecione um consultor' },
            ],
            form: {
                consultor: { title: 'Consultor' },
                periodo: { title: 'Mês', value: '' },
                button: { title: 'GERAR PDF', disabled: false }
            },
            loadConsulta: false,
        }
    },

    mounted() {
        this.getConsultores();
    },

    methods: {

        getConsultores()
        {
            this.$http.get(urlApiV2 + '/comissao/consultores').then(response => {
                response.data.map(consultores => {
                    this.selectConsultor.push({
                        value: consultores.id,
                        text: consultores.nome
                    })
                })
            }).catch(function (error) {
                this.launchToast(error.data.mensagem, 'warning')
            })
        },

        gerarPDF()
        {
            if(this.validationForm() === true){
                this.form.button.disabled = true;
                this.loadConsulta = true;
    
                var data = {
                    'consultor': this.selectedConsultor,
                    'periodo': this.form.periodo.value,
                };
    
                this.$http.get(urlApiV2 + `/comissao?consultor=${data.consultor}&periodo=${data.periodo}`)
                // this.$http.post(urlApiV2 + '/comissao/consultar/relatorio', data)
                .then(response => {
                    let code64 = response.data.dados;
                    var pdf = 'data:application/octet-stream;base64,' + code64;
                    var dlnk = document.getElementById('aulasPDF');
                    dlnk.download="novoCFC.pdf";
                    dlnk.href = pdf;
                    dlnk.click();
                    this.launchToast(response.data.mensagem, 'success')
                    this.form.button.disabled = false;
                    this.loadConsulta = false;

                }).catch(error => {
                    this.launchToast(error.data.mensagem, 'warning')
                    this.form.button.disabled = false;
                    this.loadConsulta = false;
                })
            }
        },

        validationForm()
        {
            if(this.selectedConsultor === '')
            {
                this.launchToast('Selecione um consultor!', 'warning')
                return false;
            }
            else if(this.form.periodo.value === '')
            {
                this.launchToast('Selecione um período!', 'warning')
                return false;
            }
            else
            {
                return true;
            }
        },

        launchToast(mensagem, icone)
        {
            this.$toasted.show(mensagem, {
                position: 'top-right',
                icon: icone
            });
        }

    },
}
</script>

<style lang="scss" scoped>
    #Comissoes
    {
        input.form-control {
            margin-top: 0px;
        }

        .spinner-grow {
            width: 1rem;
            height: 1rem;
        }

        .btn.btn-success {
            background-color: #20c997 !important;
            box-shadow: none;
            color: white;
        }

        .btn.btn-success:hover {
            box-shadow: none;
            box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
        }

        .espacamento-oculto {
            color: white;
            user-select: none;
        }
    }
</style>